export default __webpack_public_path__ + "static/media/blog-43-1.be26e977.jpg";